export default __webpack_public_path__ + "static/media/personal_sandbox.78cba8ee.png";